import { Box, Button, Fab, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  addAssociatedUser,
  getAssociatedUser,
  updateAssociatedUser,
} from "./associatedUsersApi";
import Swal from "sweetalert2";
import AssociatedCard from "./associatedCard";
import AddAssociatedUser from "./addAssociatedUser";
import ScopeModal from "./scopeModal";
import {
  addUser,
  getUsers,
  updateUser,
} from "./associatedUsersCustomApiHandler";
import PluseIconn from "../../assets/img/icons/plus_icon.png";
export default function AssociatedUsers() {
  const [open2, setOpen2] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, total: 1 });
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [associatedUsers, setAssociatedUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const getUserObj = {
    page: 1,
    pageSize: 10,
    filterByColumn: "",
    filterValue: "",
    searchByColumn: "",
    searchValue: "",
    orderByColumn: "",
    orderBy: "",
  };

  useEffect(() => {
    getUsers(getUserObj, getAssociatedUser, setAssociatedUsers);
  }, []);

  useEffect(() => {
    if (open === false) {
      setSelectedUser();
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          background: "#E6E6FF",
          fontFamily: "'Montserrat', sans-serif",
          height: "100vh",
          overflowY: "auto",
          px: {xs:1, sm:3},
        }}
      >
        <Box
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            borderRadius: "5px",
            color: "#01008B",
            display: "flex",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
            alignItems: "center",
            justifyContent: "space-between",
            mx: 1,
            mt: 2,
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="h6"
                            fontSize= {{ xs: "12px", sm: "13px", md: "15px" }}
            
            >Employee Access</Typography>
          </Box>
          <Button
            onClick={() => setOpen(true)}
            variant="contained"
            sx={{
              bgcolor: "#010093",
              fontWeight: 600,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            Add User
            <img
              src={PluseIconn}
              alt="plus"
              style={{ width: 18, height: 18 }}
            />
          </Button>
        </Box>
        {/* <Stack
          direction="row"
          spacing={2}
          justifyContent="end"
          sx={{
            position: {
              xs: "fixed",
              sm: "relative",
            },

            background: "white",
            width: {
              xs: "40%",
              sm: "100%",
            },
            top: {
              xs: "61px",
              sm: "0px",
            },
            right: {
              xs: "10px",
              sm: "0px",
            },
          }}
        ></Stack> */}
        <Grid
          container
          spacing={2}
          sx={{
            padding: "20px 10px 20px 20px",
            mt: {
              xs: 4,
              sm: 2,
            },
          }}
        >
          <Grid item xs={12} sx={{ height: "70vh",paddingRight: "15px", overflow: "auto", backgroundColor: "#fff", borderRadius: "10px" }}>
            <Grid container spacing={2}>
              {associatedUsers?.map((item) => {
                return (
                  <Grid item lg={3} sm={4} xs={12} md={3}>
                    <AssociatedCard
                      setOpen2={setOpen2}
                      selectedUser={selectedUser}
                      setSelectedUser={setSelectedUser}
                      setEditedItem={() => {
                        setSelectedUser(item);
                        setOpen(true);
                      }}
                      item={item}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>

        <AddAssociatedUser
          selectedUser={selectedUser}
          open={open}
          setSelectedUser={setSelectedUser}
          setOpen={setOpen}
          addUser={(param) =>
            addUser(
              param,
              addAssociatedUser,
              Swal,
              getUserObj,
              getAssociatedUser,
              setAssociatedUsers
            )
          }
          updateUser={(guid, param) =>
            updateUser(
              guid,
              param,
              updateAssociatedUser,
              Swal,
              getUserObj,
              getAssociatedUser,
              setAssociatedUsers
            )
          }
        />
        <ScopeModal
          open={open2}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          getUser={() =>
            getUsers(getUserObj, getAssociatedUser, setAssociatedUsers)
          }
          setOpen={setOpen2}
        />
      </Box>
    </>
  );
}
